import React, { useState, useEffect } from 'react';
import io from 'socket.io-client';
import iov4 from 'socket.io-client-v4';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Alert from '@material-ui/lab/Alert';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

import SocketActions from '../../../components/websocket/SocketActions';


const styles = {
    container: {
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: "#ccc",
        borderRadius: 5,
        margin: 10,
        padding: 10,
        // marginBottom: 20,
        // marginTop: 20,
    }
};

function WebsocketClient() {
    const [socket, setSocket] = useState(null);
    const [url, setUrl] = useState("ws://localhost:8080");
    const [userId, setUserId] = useState("");
    const [accessToken, setAccessToken] = useState("");
    const [conStatus, setConStatus] = useState(0);
    // -1 connecting, 0 - not connected, 1 - connected
    const [error, setError] = useState(null);
    const [socketVersion, setSocketVersion] = useState("4");

    useEffect(() => {
        // console.log("socket - ", socket)

        return () => {
            if (socket) {
                socket.close();
            }
        }
    }, [socket]);

    if (socket) {
        socket.on("connect", () => { setConStatus(1) });
        socket.on("disconnect", () => { setConStatus(0); setSocket(null) });
        socket.on("error", (e) => { setError(e); setConStatus(0) });
        socket.on("connect_error", (e) => { setError("CONNECT_ERROR : " + e.message); setConStatus(0) });
    }

    const connectToSocket = () => {
        try {
            setError(null);
            setConStatus(-1); // connecting

            const ioClient = socketVersion === "2" ? io : iov4;

            setSocket(ioClient(url, {
                //force use websocket
                transports: ["websocket"],
                upgrade: false,

                // transportOptions: {
                //   websocket: {
                //     extraHeaders: {
                //       "x-clientid": "abc",
                //     },
                //   },
                // },
                query: {
                    accessToken,
                    userId
                },
            }));
        } catch (error) {
            console.log("error - ", error)
            setError(error.message)
        }

    }

    const disconnectSocket = () => {
        if (socket) {
            socket.close();
        }
    }

    const changeSocketVersion = (event) => {
        setSocketVersion(event.target.value);
    }

    return (
        <Box >

            <Box m={2} display="flex" flexDirection="column" alignItems="center" style={styles.container}>
                <Typography variant="h6" align="center">{`Connect${conStatus === 1 ? "ed" : ""} To Socket Server`}</Typography>

                {conStatus !== 1 &&
                    <>
                        <FormControl component="fieldset">
                            <Box display={"flex"} flexDirection={"row"} alignItems="center">

                                <FormLabel component="legend">Socket IO Version : &nbsp;&nbsp;</FormLabel>
                                <RadioGroup name="socket-version" value={socketVersion} onChange={changeSocketVersion}>
                                    <Box display={"flex"} flexDirection={"row"}>
                                        <FormControlLabel value={"2"} control={<Radio />} label="Version 2.x.x" />
                                        <FormControlLabel value={"4"} control={<Radio />} label="Version 4.x.x" />
                                    </Box>
                                </RadioGroup>
                            </Box>
                        </FormControl>
                        <TextField
                            id="txt-url"
                            label="URL (without '/socket.io/')"
                            variant="standard"
                            multiline
                            value={url}
                            fullWidth
                            onChange={e => setUrl(e.target.value)}
                            disabled={conStatus !== 0}
                        />
                        <TextField
                            id="txt-user"
                            label="User ID or UID"
                            variant="standard"
                            multiline
                            fullWidth
                            value={userId}
                            onChange={e => setUserId(e.target.value)}
                            disabled={conStatus !== 0}
                        />
                        <TextField
                            id="txt-token"
                            label="Access Token"
                            variant="standard"
                            multiline
                            fullWidth
                            value={accessToken}
                            onChange={e => setAccessToken(e.target.value)}
                            disabled={conStatus !== 0}
                        />
                    </>}

                <Box display="flex" flexDirection="column" alignItems="center">
                    {
                        !!error && <Alert severity="error">{typeof error === 'string' ? error : "Something went wrong"}</Alert>
                    }
                    {conStatus !== 1 &&
                        <>
                            <Box m={2}>
                                <Button
                                    variant="contained"
                                    onClick={connectToSocket}
                                    // disabled={!url || !userId || isNaN(userId) || !accessToken || conStatus === -1}
                                    disabled={!url || conStatus === -1}
                                >
                                    Connect
                                </Button>
                            </Box>
                        </>
                    }

                    {!!socket && conStatus === 1 &&
                        <>
                            <Alert severity="success">{`Socket connected! Socket ID - ${socket.id}`}</Alert>
                            <Box m={2}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={disconnectSocket}
                                >
                                    Disconnect
                                </Button>
                            </Box>
                        </>}
                </Box>

            </Box>
            <SocketActions socket={socket} />

        </Box>
    );
}
export default WebsocketClient;
